import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormFolderMove, { FORM_FOLDER_MOVE_ID } from '../forms/FormFolderMove';
import { useTranslation } from 'react-i18next';

export default function SheetFolderMove({ open, onClose, onSubmit, item, isSubmitting = false }) {
    const { t } = useTranslation();
    const moveLabel =
        item?.type === 'photo'
            ? t('folders:deplacerLaPhoto')
            : item?.type === 'procedure_report'
              ? t('folders:deplacerLeRapport')
              : t('folders:deplacerLeDossier');

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{moveLabel}</SheetTitle>
                </SheetHeader>

                <FormFolderMove item={item} onSubmit={onSubmit} />

                <SheetFooter className="px-6 py-4 border-t border-border flex gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        onClick={onClose}
                        className="flex-1"
                        disabled={isSubmitting}
                    >
                        {t('folders:annuler')}
                    </Button>
                    <SubmitButton
                        form={FORM_FOLDER_MOVE_ID}
                        className="flex-1 px-4 py-3 rounded-lg"
                        isSubmitting={isSubmitting}
                        loadingText={t('folders:deplacement')}
                    >
                        {t('folders:deplacerIci')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
